// activityInviteFriend
export default {
  routerTitle: '邀请好友',
  shareTitle: '新客户三重奖赏，享最高HKD 3,800新人礼包！',
  shareDesc: '参与入金交易达标即可获得！',
  btnTxt: '邀请好友 领取奖励',
  people: '人',

  cardOneLabel1: '分享好友',
  cardOneLabel2: '注册开户',
  cardOneLabel3: '好友入金',

  cardTwoTitle: '邀请好友入金获取奖励',
  cardTwoTableLHeader: '邀请人数',
  cardTwoTableRHeader: '邀请奖励',
  cardTwoTableEmptyTips: '暂无数据',
  cardTwoTips:
    '注：<br/>1、邀请11-30人以上，每邀请1位达标入金≥2w HKD，交易≥1笔，可获得HKD450。<br/>2、被邀请人需满足入金≥2w HKD，交易≥1笔，详看活动规则。',
  // 邀请活动2
  cardTwoTips2:
    '注：1、邀请11-30人以上，每邀请1位达标入金≥HKD 2W，交易≥1笔，可获得HKD 450。<br/>2、被邀请人需满足入金≥HKD 2W，交易≥1笔，详看活动规则。<br/>3、被邀请人奖励：首次入金达标≥HKD 2W，30天内无出金记录且交易≥1笔，最高可拿HKD 3800新人礼包！',

  cardThreeTitle: '我的邀请',
  cardThreeTableLHeader: '我的邀请',
  cardThreeTableRHeader: '邀请时间',
  cardThreeTableRHeader2: '达标情况',
  cardThreeTableEmptyTips: '暂无邀请进度',
  cardThreePreviewAmount: '预估可得',
  cardThreeHasInvited: '已邀请',
  cardThreeEarnReward: '获得 {name} 奖励',

  cardFourTitle: '邀请排行榜',
  cardFourTableLHeader: '用户昵称',
  cardFourTableRHeader: '邀请人数',
  cardFourTableEmptyTips: '暂无数据，等你来上榜',
  cardFourTips:
    '注：排名前六的用户分别获得IPhone 14 (256G)、Air Pods Pro、Apple HomePod mini、科沃斯扫地机器人K650、米家喷墨打印一体机、华为手环7标准版',
  cardFourTips2:
    '注：排名前六的用户分别获得华为Mate 60 Pro 12GB、Air Pods Pro、Apple HomePod mini、科沃斯扫地机器人K650、米家喷墨打印一体机、华为手环7标准版',

  inviteLinkCopyTips: '邀请好友链接已复制'
}
